// Central content + assets for JM Mevada And Pattern Works

export const LOGO = "https://customer-assets-agu9un31.emergentagent.net/job_mevada-pattern-works/artifacts/4d5chtfv_WhatsApp%20Image%202026-08-19%20at%202.21.43%20PM.jpeg";

export const COMPANY = {
  name: "JM Mevada Pattern Works",
  short: "JM Mevada",
  tagline: "55+ Years of Pattern Making & Manufacturing Excellence",
  phone: "+91 99799 35356",
  phoneRaw: "919979935356",
  whatsapp: "919979935356",
  email: "mevada_dilip@yahoo.com",
  address: "Plot No 4, Shiv Bhumi Industrial Park-3, Bakrol Bujrang, Ahmedabad-382433, Gujarat",
  hours: "Mon – Sat: 9:00 AM – 7:00 PM",
};

export const IMAGES = {
  heroCnc: "https://images.pexels.com/photos/8956445/pexels-photo-8956445.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  foundryPour: "https://images.unsplash.com/photo-1684259499227-e9844ab79747?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  moltenPour: "https://images.pexels.com/photos/6804260/pexels-photo-6804260.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  woodenPatterns: "https://images.unsplash.com/photo-1768573490117-658e59a49fe7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  woodShelf: "https://images.unsplash.com/photo-1528441498660-efe78ffb632d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  cncCloseup: "https://images.unsplash.com/photo-1666618090858-fbcee636bd3e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  cncSparks: "https://images.unsplash.com/photo-1711418235334-8895331a6cf9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  cncCoolant: "https://images.pexels.com/photos/8865187/pexels-photo-8865187.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=1200",
  lathe: "https://images.unsplash.com/photo-1666634157070-6fd830fb5672?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  plantInterior: "https://images.unsplash.com/photo-1496247749665-49cf5b1022e9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  steelCrane: "https://images.unsplash.com/photo-1474674556023-efef886fa147?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  pumpGreen: "https://images.unsplash.com/photo-1705129472480-2145aecb9aaa?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  compressorBlue: "https://images.unsplash.com/photo-1720670996646-2f5d69a10ee7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  turbineBlades: "https://images.unsplash.com/photo-1694160027547-b0696cf1ad45?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  jetEngine: "https://images.pexels.com/photos/36920312/pexels-photo-36920312.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=1200",
  gasCompressor: "https://images.unsplash.com/photo-1655874837055-7adc909ae602?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  oilGas: "https://images.pexels.com/photos/35645884/pexels-photo-35645884.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=1200",
  factoryWide: "https://images.pexels.com/photos/36397942/pexels-photo-36397942.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  matWood: "https://images.unsplash.com/photo-1634672652995-ee7525bce595?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  matMetal: "https://images.unsplash.com/photo-1776235239513-1bf26921e458?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  matAluminium: "https://images.unsplash.com/photo-1516297702292-c919b6adea0c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  injectionMoulding: "https://images.unsplash.com/photo-1730705788367-dbd288c40ee7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

export const PRODUCT_PHOTOS = [
  "https://customer-assets-agu9un31.emergentagent.net/job_mevada-pattern-works/artifacts/38135ncm_WhatsApp%20Image%202026-08-19%20at%202.54.04%20PM%20%281%29.jpeg",
  "https://customer-assets-agu9un31.emergentagent.net/job_mevada-pattern-works/artifacts/ocwui8d2_WhatsApp%20Image%202026-08-19%20at%202.54.05%20PM.jpeg",
  "https://customer-assets-agu9un31.emergentagent.net/job_mevada-pattern-works/artifacts/8yyp54pf_WhatsApp%20Image%202026-08-19%20at%202.54.06%20PM.jpeg",
  "https://customer-assets-agu9un31.emergentagent.net/job_mevada-pattern-works/artifacts/vcz0o8ng_WhatsApp%20Image%202026-08-19%20at%203.00.36%20PM.jpeg",
  "https://customer-assets-agu9un31.emergentagent.net/job_mevada-pattern-works/artifacts/routkwcz_WhatsApp%20Image%202026-08-19%20at%203.00.36%20PM%20%281%29.jpeg",
  "https://customer-assets-agu9un31.emergentagent.net/job_mevada-pattern-works/artifacts/j3i0l9ck_WhatsApp%20Image%202026-08-19%20at%202.54.04%20PM.jpeg",
  "https://customer-assets-agu9un31.emergentagent.net/job_mevada-pattern-works/artifacts/u2tvsfnp_WhatsApp%20Image%202026-08-19%20at%202.53.59%20PM.jpeg",
  "https://customer-assets-agu9un31.emergentagent.net/job_mevada-pattern-works/artifacts/hmfai9hm_WhatsApp%20Image%202026-08-19%20at%202.54.02%20PM.jpeg",
  "https://customer-assets-agu9un31.emergentagent.net/job_mevada-pattern-works/artifacts/ga3wlgj1_WhatsApp%20Image%202026-08-19%20at%202.53.57%20PM.jpeg",
  "https://customer-assets-agu9un31.emergentagent.net/job_mevada-pattern-works/artifacts/uw5qnosq_WhatsApp%20Image%202026-08-19%20at%202.53.57%20PM%20%281%29.jpeg",
];

export const STATS = [
  { value: 55, suffix: "+", label: "Years Experience" },
  { value: 72000, suffix: "+", label: "Patterns Manufactured" },
  { value: 3, suffix: "", label: "Generations of Experience" },
  { value: 100, suffix: "%", label: "Any Size Pattern Capability" },
];

export const CAPABILITIES = [
  "Industrial Patterns", "Wooden Patterns", "Metal Patterns", "Aluminium Patterns",
  "Dies & Tooling", "CNC Machining", "Custom Engineering Work", "Manufacturing & Sourcing Support",
];

export const CAPABILITIES_FULL = [
  { title: "Industrial Pattern Manufacturing", desc: "Precision patterns engineered to exact foundry and casting specifications." },
  { title: "Wooden Patterns", desc: "Traditional craftsmanship for cost-effective, accurate wooden patterns." },
  { title: "Metal Patterns", desc: "Durable metal patterns for high-volume, repeatable production runs." },
  { title: "Aluminium Patterns", desc: "Lightweight aluminium patterns with fine dimensional accuracy." },
  { title: "Any Size Pattern Manufacturing", desc: "From small components to large heavy patterns — no size limitation." },
  { title: "Dies & Tooling", desc: "Custom dies and tooling designed for your production process." },
  { title: "CNC Machining", desc: "Computer-controlled machining for tight tolerances and consistency." },
  { title: "Custom Engineering Work", desc: "Bespoke engineering solutions from concept to finished product." },
  { title: "Pattern Duplication", desc: "Accurate reproduction of existing patterns and samples." },
  { title: "Pattern Modification", desc: "Rework and modification of patterns to updated requirements." },
  { title: "Manufacturing & Sourcing Support", desc: "Reliable outsourced manufacturing and sourcing partnership." },
];

export const MATERIALS = [
  { name: "Wood", code: "WD", img: IMAGES.matWood },
  { name: "Metal", code: "MT", img: IMAGES.matMetal },
  { name: "Aluminium", code: "AL", img: IMAGES.matAluminium },
];

export const PRODUCTS = [
  "Motor & Motor Body Patterns",
  "Pump & Heavy Pump Patterns",
  "Gas Compressor Patterns",
  "Gas Compressor Cylinder Patterns",
  "Gas Compressor Frame Patterns",
  "Turbine Patterns",
  "Wind Mill Patterns",
  "Machine Moulding Metal Patterns",
  "Injection Moulding Tooling",
  "Beverage & Packaging Machinery Patterns",
  "Pharmaceutical Machinery Components",
  "Custom Industrial Patterns",
];

export const INDUSTRIES = [
  { title: "Engineering & Industrial Machinery", img: IMAGES.plantInterior },
  { title: "Compressor & Gas Equipment", img: IMAGES.compressorBlue },
  { title: "Automotive Components", img: IMAGES.cncCloseup },
  { title: "Pumps & Hydraulic Equipment", img: IMAGES.pumpGreen },
  { title: "Renewable Energy", img: IMAGES.jetEngine },
  { title: "Turbine & Power Equipment", img: IMAGES.turbineBlades },
  { title: "Oil & Gas", img: IMAGES.oilGas },
  { title: "Moulding & Foundry", img: IMAGES.moltenPour },
  { title: "Injection Moulding", img: IMAGES.injectionMoulding },
  { title: "Beverage & Packaging Machinery", img: IMAGES.factoryWide },
  { title: "Pharmaceutical Machinery", img: IMAGES.steelCrane },
];

export const WHY_CHOOSE = [
  "55+ Years Experience", "72,000+ Patterns Manufactured", "Custom Manufacturing",
  "Multiple Material Options", "Competitive Pricing", "On-Time Delivery",
  "Long-Term Manufacturing Partner",
];

export const PROCESS = [
  { step: "01", name: "Requirement", desc: "We study your drawings, samples and technical specifications." },
  { step: "02", name: "Planning", desc: "Material, method and tooling planned for accuracy and cost." },
  { step: "03", name: "Manufacturing", desc: "Skilled craftsmen and CNC machining build the pattern." },
  { step: "04", name: "Quality Check", desc: "Dimensional inspection against your requirements." },
  { step: "05", name: "Finishing", desc: "Surface finishing and final detailing for production use." },
  { step: "06", name: "Delivery", desc: "On-time dispatch with reliable manufacturing support." },
];

export const TIMELINE = [
  { year: "1969", title: "The Beginning", desc: "Jagjivanbhai Mevada establishes JM Mevada & Co., laying the foundation of a pattern-making legacy." },
  { year: "1980s", title: "Building Reputation", desc: "The workshop earns trust across foundries for precision and reliability in industrial patterns." },
  { year: "1990s", title: "Next Generation", desc: "Dilipbhai Mevada carries the craft forward, expanding capabilities and material expertise." },
  { year: "2000s", title: "Modern Machining", desc: "CNC machining and advanced tooling added to complement traditional craftsmanship." },
  { year: "Today", title: "72,000+ Patterns", desc: "Three generations of experience serving industries across India as a trusted partner." },
];

export const NAV = [
  { label: "Home", to: "/" },
  { label: "About Us", to: "/about" },
  { label: "Capabilities", to: "/capabilities" },
  { label: "Mission & Vision", to: "/mission-vision" },
  { label: "Our Products", to: "/products" },
  { label: "Industries We Serve", to: "/industries" },
  { label: "Enquiry", to: "/enquiry" },
  { label: "Reach Us", to: "/reach-us" },
];
